import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, Card, WingBlank, WhiteSpace, List, Button, Modal, InputItem, Picker, Toast, ActionSheet, Checkbox } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import { createForm } from 'rc-form';
import '../styles/AgentDelegate.css';
import iconAvatar from '../medias/avatar.svg';

const history = require("history").createHashHistory()
const alert = Modal.alert
const CheckboxItem = Checkbox.CheckboxItem;

class AgentDelegate extends Component {
    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4,
            agentProfile: {
                profitPoint: 0,
                maxSites: 0
            },
            showCreateModal: false,
            enableCreate: true,
            showUpdateModal: false,
            enableUpdate: true,
            selectedItem: null,
            sites: []
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 80;
        this.setState({
            height
        })
        this.loadSites()
        this.loadData(1)
    }

    loadSites = (callback) => {
        DataFetcher.agentSites((resp) => {
            this.setState({
                sites: resp.data
            }, () => {
                callback&&callback()
            })
        })
    }

    loadData = (pageNum) => {
        DataFetcher.pageDelegate({
            pageNum,
            pageSize: 10
        }, {
            success: (resp) => {
                let data = resp.data
                this.pageNum = data.pageNum;
                this.pageSize = data.pageSize;
                this.pages = data.pages;
                let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : {}
                this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
                this.setState({
                    dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                    isLoading: false,
                    hasMore: this.pageNum < this.pages,
                })
            }
        })
    }

    onEndReached = (event) => {
        const { isLoading, hasMore } = this.state

        if (isLoading || !hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadData(++this.pageNum)
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.forEach((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
        })
        return rowDatas;
    }

    handleItemClick = (rowData) => {
        const options = [
            { icon: <i className='iconfont icon-xiugai' style={{color:'#04bbc5', fontSize: 30}}/>, title: '编辑信息' }
        ]
        if(rowData.delegateUserId) {
            options.push({ icon: <i className='iconfont icon-jiechudiyadengji' style={{color:'orange', fontSize: 30}}/>, title: '解除绑定' })
        }
        options.push({ icon: <i className='iconfont icon-shanchu1' style={{color: 'orangered', fontSize: 30}}/>, title: '删除帐号' })
        let optionMap = {}
        for(let i = 0; i < options.length; i++) {
            optionMap[i] = options[i].title
        }
        ActionSheet.showShareActionSheetWithOptions({
            options,
            title: '操作',
            message: rowData.agentName,
        },
        (buttonIndex) => {
            let buttonTitle = optionMap[buttonIndex]
            if(!buttonTitle) return

            if(buttonTitle === '编辑信息') {
                this.setState({
                    showUpdateModal: true,
                    selectedItem: rowData
                })
            } else if(buttonTitle === '解除绑定') {
                this.handleUnbindClick(rowData)
            } else if(buttonTitle === '删除帐号') {
                this.handleDeleteClick(rowData)
            } else {
                Toast.info('功能开发中')
            }
        });
    }

    handleCreateClick = () => {
        this.setState({
            enableCreate: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('create_') !== 0) {
                        continue
                    }

                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableCreate: true
                        })
                        return
                    }
                }
            }

            let siteIds = []
            for(let prop in fieldsValue) {
                if(prop.indexOf('create_siteIds_') !== 0) {
                    continue
                }

                let siteId = prop.substring('create_siteIds_'.length)
                if(fieldsValue[prop]) {
                    siteIds.push(siteId)
                }
            }
            if(!siteIds.length) {
                Toast.fail('请选择授权门店')
                this.setState({
                    enableCreate: true
                })
                return
            }

            const params = {
                delegateName: fieldsValue.create_delegateName,
                siteIds: siteIds.join(','),
                delegateType: fieldsValue.create_delegateType[0]
            }
            DataFetcher.createDelegate(params, {
                success: (resp) => {
                    this.setState({
                        showCreateModal: false
                    })
                    this.props.form.resetFields()
                    this.loadData(1)
                },
                completed: () => {
                    this.setState({
                        enableCreate: true
                    })
                }
            })
        });
    }

    handleUpdateClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        this.setState({
            enableUpdate: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('update_') !== 0) {
                        continue
                    }

                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableUpdate: true
                        })
                        return
                    }
                }
            }

            let siteIds = []
            for(let prop in fieldsValue) {
                if(prop.indexOf('update_siteIds_') !== 0) {
                    continue
                }

                let siteId = prop.substring('update_siteIds_'.length)
                if(fieldsValue[prop]) {
                    siteIds.push(siteId)
                }
            }
            if(!siteIds.length) {
                Toast.fail('请选择授权门店')
                this.setState({
                    enableUpdate: true
                })
                return
            }

            const params = {
                id: selectedItem.id,
                delegateName: fieldsValue.update_delegateName,
                siteIds: siteIds.join(','),
                delegateType: fieldsValue.update_delegateType[0]
            }
            DataFetcher.updateDelegate(params, {
                success: (resp) => {
                    this.setState({
                        showUpdateModal: false
                    })
                    this.props.form.resetFields()
                    this.loadData(1)
                },
                completed: () => {
                    this.setState({
                        enableUpdate: true
                    })
                }
            })
        });
    }

    handleUnbindClick = (rowData) => {
        if(!rowData) return

        alert('确认要解除绑定?', rowData.delegateName, [
            { text: '取消', onPress: () => {} },
            { text: '确认', onPress: () => {
                DataFetcher.unbindDelegate({
                    id: rowData.id
                }, {
                    success: (resp) => {
                        Toast.info('已解除绑定')
                        this.loadData(1)
                    }
                })
            }},
          ])
    }

    handleDeleteClick = (rowData) => {
        if(!rowData) return

        alert('确认要删除帐号?', rowData.delegateName, [
            { text: '取消', onPress: () => {} },
            { text: '确认', onPress: () => {
                DataFetcher.deleteDelegate({
                    id: rowData.id
                }, {
                    success: (resp) => {
                        Toast.info('已删除帐号')
                        this.loadData(1)
                    }
                })
            }},
          ])
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    doResolveDelegateType = (record) => {
        if(record.delegateType === 'VIEWER') {
            return '查看'
        } else if(record.delegateType === 'OPERATOR') {
            return '运营'
        } else {
            return ''
        }
    }

    doResolveSiteNames = (record) => {
        if(!record.siteIds) return ''

        let items = record.siteIds.split(',')
        if(!items||!items.length) return ''

        const { sites } = this.state
        let siteMap = {}
        for(let site of sites) {
            siteMap[site.id] = site
        }

        let siteNames = []
        for(let item of items) {
            if(siteMap[item]) {
                siteNames.push(siteMap[item].siteName)
            }
        }
        return siteNames.join(' ')
    }

    isSiteChecked = (record, siteId) => {
        if(!record||!record.siteIds) return false

        let items = record.siteIds.split(',')
        if(!items||!items.length) return false

        for(let item of items) {
            if(item === siteId) {
                return true
            }
        }
        return false
    } 

    renderRow = (rowData, sectionId, rowId) => {
        return (
            <WingBlank size='sm'>
                <div onClick={() => {this.handleItemClick(rowData)}}>
                    <Card key={rowId}>
                        <Card.Header
                            title={<span className='word-ellipsis'>&nbsp;{rowData.delegateName}</span>}
                            thumb={<img src={rowData.delegateAvatar?rowData.delegateAvatar:iconAvatar} alt='avatar'/>}
                            extra={<div><span className='value'>{rowData.delegateUserId?'':'待绑定'}</span></div>}
                        />
                        <Card.Body>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>权限类型：</span> 
                                    <span className='value'>{this.doResolveDelegateType(rowData)}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>微信昵称：</span> 
                                    <span className='value'>{rowData.delegateNickName}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis' style={{width: '100%'}}>
                                    <span className='label'>授权门店：</span> 
                                    <span className='value'>{this.doResolveSiteNames(rowData)}</span>
                                </div>
                                
                            </div>
                            <div className={`info-row${rowData.delegateUserId?' hide':''}`} style={{fontSize: 14, marginTop: 15}}>
                                <span style={{color:'gray'}}>通知用户在公众号发送邀请码&nbsp;&nbsp;</span>
                                <span style={{color:'#04bbc5'}}>{rowData.verifyCode}</span>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </WingBlank>
        )
    }

    doRenderCreateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showCreateModal, enableCreate, sites } = this.state
       
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showCreateModal}
                    onClose={() => {
                        this.setState({showCreateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>新建子帐号</div>}>
                        <InputItem {...getFieldProps('create_delegateName', {
                                initialValue: '',
                                rules: [{required: true, message: '请填写子帐号名'}],
                            })}>
                            子帐号名
                        </InputItem>
                        <Picker 
                            cols={1}
                            data={[{label: '查看', value: 'VIEWER'}, {label: '运营', value: 'OPERATOR'}]}
                            {...getFieldProps('create_delegateType', {
                                rules: [{required: true, message: '请选择权限类型'}],
                            })} 
                            >
                            <List.Item arrow="horizontal">权限类型</List.Item>
                        </Picker>
                        <List.Item>
                            <div style={{fontSize: 17, color: '#555', width: '100%'}}>授权门店</div>
                        </List.Item>
                        <div className='site-select'>
                            {sites.map(item => (
                                <CheckboxItem key={item.id}
                                    {...getFieldProps('create_siteIds_' + item.id, {
                                    })}
                                >
                                    {item.siteName}
                                </CheckboxItem>
                            ))}
                        </div>
                        <List.Item>
                            <Button type="primary" onClick={this.handleCreateClick} disabled={!enableCreate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderUpdateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showUpdateModal, enableUpdate, selectedItem, sites } = this.state
       
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showUpdateModal}
                    onClose={() => {
                        this.setState({showUpdateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>编辑信息</div>}>
                        <InputItem {...getFieldProps('update_delegateName', {
                                initialValue: selectedItem?selectedItem.delegateName:null,
                                rules: [{required: true, message: '请填写子帐号名'}],
                            })}>
                            子帐号名
                        </InputItem>
                        <Picker 
                            cols={1}
                            data={[{label: '查看', value: 'VIEWER'}, {label: '运营', value: 'OPERATOR'}]}
                            {...getFieldProps('update_delegateType', {
                                initialValue: selectedItem?[selectedItem.delegateType]:[],
                                rules: [{required: true, message: '请选择权限类型'}],
                            })} 
                            >
                            <List.Item arrow="horizontal">权限类型</List.Item>
                        </Picker>
                        <List.Item>
                            <div style={{fontSize: 17, color: '#555', width: '100%'}}>授权门店</div>
                        </List.Item>
                        <div className='site-select'>
                            {sites.map(item => (
                                <CheckboxItem key={item.id} defaultChecked={this.isSiteChecked(selectedItem, item.id)}
                                    {...getFieldProps('update_siteIds_' + item.id, {
                                        initialValue: this.isSiteChecked(selectedItem, item.id)
                                    })}
                                >
                                    {item.siteName}
                                </CheckboxItem>
                            ))}
                        </div>
                        <List.Item>
                            <Button type="primary" onClick={this.handleUpdateClick} disabled={!enableUpdate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    render() {
        const {dataSource, isLoading} = this.state;
        return (
            <div className='page-agent-delegate'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                    rightContent={<i className='iconfont icon-tianjia' style={{color:'black'}} onClick={() => {this.setState({showCreateModal: true})}}></i>}
                >
                    帐号授权
                </NavBar>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 50
                    }}
                />
                {this.doRenderCreateModal()}
                {this.doRenderUpdateModal()}
            </div>
        )
    }
}

export default createForm()(AgentDelegate);


// WEBPACK FOOTER //
// ./src/modules/AgentDelegate.js